import { CompressionSubSamplingEnum } from '../../space-wall/shared/enums/compression-sub-sampling.enum';
import { SpaceWallConstants } from '../../space-wall/space-wall.constants';
import { WallSharedConstants } from '../../wall-shared.constants';
import { WallMonitor } from './monitor.type';

export class WallMonitorCalibrationModel {
    ScreenName: string;
    WallIndex: number;
    Width: number = WallSharedConstants.DEFAULT_WALL_RESOLUTION_W;
    Height: number = WallSharedConstants.DEFAULT_WALL_RESOLUTION_H;
    LeftPosition: number = WallSharedConstants.DEFAULT_MONITOR_WIDTH;
    TopPosition: number = WallSharedConstants.DEFAULT_MONITOR_TOP;
    Angle: number = WallSharedConstants.DEFAULT_MONITOR_ANGLE;
    CompressionQuality: number;
    CompressionSubSampling: number;
    Brightness: number;
    Contrast: number;

    constructor(monitor: WallMonitor) {
        monitor.CompressionQuality = monitor.CompressionQuality || SpaceWallConstants.DEFAULT_MONITOR_COMPRESSION_QUALITY;
        monitor.CompressionSubSampling = monitor.CompressionSubSampling || CompressionSubSamplingEnum.YUV444;
        monitor.Brightness = monitor.Brightness || SpaceWallConstants.DEFAULT_MONITOR_BRIGHTNESS;
        monitor.Contrast = monitor.Contrast || SpaceWallConstants.DEFAULT_MONITOR_CONTRAST;
        return monitor as WallMonitorCalibrationModel;
    }
}
